export const environment = {
  production: false,
  googleApiKey: 'AIzaSyAdKYTXOga8LVv8oX-NSFG8S5hjunu7_qg',
  apiUrl: 'https://localhost:8001/api',
  code: '',
  dashboard: '/dashboard',
  bugsnagApiKey: '691cd6149de59c8693b21e6e9826e173',
  bugsnagEnv: 'Development',
  recaptchaApi: '6LfeW9saAAAAAPWtOiD0ly77pxy3mxibLWJd2-yH',
  ga: '',
  buttonTitleTextTransform: 'UpperCase',
  titleTextTransform: 'SentenceCase',
  greenIdEnv: 'test',
  greenIdCode: '9nU-Se3-XMt-fbU',
  greenIdVerifiedIcon: 'fingerprint',
  greenIdNotVerifiedIcon: 'fingerprint',
  lockedIcon: 'lock',
  entryFileAttachedIcon: '',
  entryFileDefaultIcon: '',
  underlyingInvestmentsChartColors: undefined,
  b2cClientId: '',
  b2cPolicySignIn: '',
  b2cSignInAuthority: '',
  b2cPolicyElevatedSignIn: '',
  b2cElevatedSignInAuthority: '',
  b2cPolicyAdviserElevatedSignIn: '',
  b2cAdviserElevatedSignInAuthority: '',
  b2cAuthorityDomain: '',
  b2cReadScope: '',
  b2cWriteScope: '',
  b2cApiEndpoint: 'https://localhost:8001/api/**',
  b2cLogoutUrl: '/',
  postLogoutRedirectUri: '/',
  takeMeWithYouUrl: 'take-me-with-you',
  underlyingInvestment: 'underlying-investment',
  showButtonIcon: true,
  startAPension: {
    eligibilitySection: {
      showCitizenQuestion: true,
    },
  },
  views: {
    global: {
      displayEntryIcons: true,
    },
    loginView: {
      animateContentWrapper: false,
      animateWrapper: true,
    },
    historicalChart: {
      displayUnits: true,
    },
    memberViewOverview: {
      displayMemberNumber: false,
      displayAccountNumber: false,
      showChosenName: false,
    },
    investmentEdit: {
      showComplexComponent: true,
    },
    takeMeWithYou: {
      displayChoiceOfFundForm: true,
    },
    insurance: {
      showEffectiveDate: false,
      showLapseColumn: false,
    },
    calculator: {
      superannuationCalculator: true,
      retirementProjectionCalculator: true,
      superContributionOptimiser: true,
    },
    memberAlerts: {
      BindingNominationOfBeneficiaries: false,
    },
  },
};
